/* RYTM Variant Buy Box (bundle + flavour selectors) behaviour. Vanilla JS, no dependencies, safe for multiple instances per page. */
(function () {
  'use strict';

  function initGallery(root) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('.rytm-varbox__image-group'));

    groups.forEach(function (group) {
      var images = Array.prototype.slice.call(group.querySelectorAll('.rytm-varbox__image'));
      var dots = Array.prototype.slice.call(group.querySelectorAll('.rytm-varbox__image-dot'));
      if (images.length < 2) return;

      function currentIndex() {
        for (var i = 0; i < images.length; i++) {
          if (images[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      function setActive(index) {
        images.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      // Used by the flavour selectors to jump to a variant's own image.
      group.rytmSetActive = function (index) {
        if (index >= 0 && index < images.length) setActive(index);
      };

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { setActive(i); });
      });

      var prevBtn = group.querySelector('.rytm-varbox__image-arrow--prev');
      var nextBtn = group.querySelector('.rytm-varbox__image-arrow--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var i = currentIndex();
          setActive(i === 0 ? images.length - 1 : i - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var i = currentIndex();
          setActive(i === images.length - 1 ? 0 : i + 1);
        });
      }
    });
  }

  function initAccordion(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.rytm-varbox__collapsible-trigger'));

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  /* ---------- Flavours (variant selectors) ----------

     Each row whose product has variants carries one <select> per product
     option plus a JSON list of its variants. Changing a select resolves the
     matching variant and writes its id onto the row's radio, which is what
     applySelection() copies into the form's hidden `id` input. Availability
     is deliberately not considered: out-of-stock variants stay addable. */

  function findVariant(variants, values) {
    var exact = variants.filter(function (v) {
      return v.options.length === values.length && v.options.every(function (opt, i) {
        return opt === values[i];
      });
    })[0];
    if (exact) return exact;

    // Mix & match: the same flavours in the other order are the same bundle,
    // so one variant per unique pair is enough.
    var wanted = values.slice().sort().join('\u0000');
    return variants.filter(function (v) {
      return v.options.length === values.length && v.options.slice().sort().join('\u0000') === wanted;
    })[0] || null;
  }

  function setText(el, text) {
    if (el && text != null) el.textContent = text;
  }

  function renderVariant(row, variant) {
    setText(row.querySelector('[data-rytm-price]'), variant.price);
    setText(row.querySelector('[data-rytm-per-day]'), variant.perDay);

    var compare = row.querySelector('[data-rytm-compare]');
    if (compare) {
      compare.hidden = !variant.compare;
      setText(compare, variant.compare);
    }

    var discount = row.querySelector('[data-rytm-discount]');
    if (discount) {
      discount.hidden = variant.percent == null;
      setText(discount.querySelector('[data-rytm-percent]'), variant.percent);
    }
  }

  function initFlavours(root, onChange) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-rytm-flavours]'), function (group) {
      var row = group.closest('[data-rytm-row]');
      var radio = row && row.querySelector('.rytm-varbox__radio');
      var json = group.querySelector('[data-rytm-variants]');
      var selects = Array.prototype.slice.call(group.querySelectorAll('.rytm-varbox__select'));
      var error = group.querySelector('[data-rytm-flavour-error]');
      if (!radio || !json || !selects.length) return;

      var variants;
      try { variants = JSON.parse(json.textContent); } catch (err) { return; }
      if (!Array.isArray(variants)) return;

      function update(showImage) {
        var values = selects.map(function (select) { return select.value; });
        var variant = findVariant(variants, values);

        if (error) error.hidden = !!variant;

        if (variant) {
          radio.dataset.variantId = variant.id;
          radio.removeAttribute('data-invalid');
          renderVariant(row, variant);

          if (showImage && variant.image) {
            var gallery = root.querySelector('.rytm-varbox__image-group[data-image-group="' + radio.dataset.image + '"]');
            if (gallery && typeof gallery.rytmSetActive === 'function') {
              gallery.rytmSetActive(variant.image - 1);
            }
          }
        } else {
          radio.setAttribute('data-invalid', 'true');
        }

        if (radio.checked) onChange(radio);
      }

      selects.forEach(function (select) {
        select.addEventListener('change', function () { update(true); });
      });

      // Sync once on load: the browser may restore earlier select values
      // (back/forward cache) without the matching variant id. The gallery is
      // left on its first image until the shopper actually picks a flavour.
      update(false);
    });
  }

  /* ---------- Cart ----------

     Self-contained AJAX add-to-cart. Deliberately NOT wired to the theme's
     <product-form-component>: that routes the add through Horizon's own
     validation and changes how out-of-stock is handled. This posts the exact
     same body the plain form was already posting, and then IGNORES the
     response — success or failure — so add-to-cart behaves exactly as it did
     with the plain form POST. The only difference is that we stay on the page
     and open the cart drawer instead of letting the browser navigate to /cart.

     Do not add error handling here: surfacing the response is precisely the
     behaviour change we're avoiding. */

  function cartSectionIds() {
    // Discovered from the DOM, never hardcoded. cart-items-component publishes
    // its own section id; the header badge lives in a different section, found
    // via the <cart-icon> element's shopify-section wrapper.
    var ids = [];

    function push(id) {
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }

    var items = document.querySelector('cart-items-component');
    if (items) push(items.dataset.sectionId);

    var icon = document.querySelector('cart-icon');
    var wrapper = icon && icon.closest ? icon.closest('[id^="shopify-section-"]') : null;
    if (wrapper) push(wrapper.id.replace('shopify-section-', ''));

    return ids;
  }

  function applySections(sections) {
    // Shopify returns each requested section as a full HTML string. Swapping
    // the inner HTML re-creates the custom elements inside, which re-upgrade
    // themselves on insertion.
    if (!sections) return false;

    var applied = false;

    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;

      var current = document.getElementById('shopify-section-' + id);
      if (!current) return;

      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('shopify-section-' + id);
      if (!fresh) return;

      current.innerHTML = fresh.innerHTML;
      applied = true;
    });

    return applied;
  }

  function refreshCartData() {
    var items = document.querySelector('cart-items-component');
    if (items && typeof items.fetchCartData === 'function') {
      try { items.fetchCartData(); } catch (err) { /* ignore */ }
    }
  }

  function openCartDrawer() {
    // Horizon's drawer is <theme-drawer id="cart-drawer"> and exposes open().
    // Re-queried on every call because applySections() may have replaced it.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Fallback: click the cart icon, the same way a shopper would.
    var icon = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (icon) {
      (icon.closest('a, button, [role="button"]') || icon).click();
      return true;
    }

    return false;
  }

  function initCart(root) {
    var form = root.querySelector('.rytm-varbox__form');
    if (!form) return;

    var submitting = false;

    form.addEventListener('submit', function (event) {
      // Without JS this listener never runs and the form posts normally, so
      // the section still works with scripts disabled.
      event.preventDefault();
      // No variant exists for the chosen flavour combination.
      if (submitting || form.dataset.invalid === 'true') return;
      submitting = true;

      var button = form.querySelector('.rytm-varbox__cta');
      if (button) button.disabled = true;

      // FormData(form) reproduces the original POST body; `sections` asks
      // Shopify to return refreshed markup for the cart drawer and header.
      var body = new FormData(form);
      var sectionIds = cartSectionIds();
      if (sectionIds.length) {
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        // Only `sections` is ever read. Status and message are deliberately
        // ignored: a refused add leaves the cart markup untouched and the
        // drawer simply opens on the existing cart, which is what the plain
        // form POST effectively did.
        .then(function (data) { return applySections(data && data.sections); })
        .catch(function () { return false; })
        .then(function (applied) {
          if (!applied) refreshCartData();
          // Let the re-inserted custom elements upgrade before opening.
          setTimeout(openCartDrawer, 0);
          submitting = false;
          if (button) button.disabled = form.dataset.invalid === 'true';
        });
    });
  }

  function initInstance(root) {
    if (root.dataset.rytmVarboxInit === 'true') return;
    root.dataset.rytmVarboxInit = 'true';

    var radios = Array.prototype.slice.call(root.querySelectorAll('.rytm-varbox__radio'));
    var variantInput = root.querySelector('[data-rytm-varbox-variant-input]');
    if (!radios.length || !variantInput) return;

    var form = root.querySelector('.rytm-varbox__form');
    var button = root.querySelector('.rytm-varbox__cta');

    function applySelection(radio) {
      root.setAttribute('data-selected', radio.dataset.image);
      variantInput.value = radio.dataset.variantId;

      // Fallback for browsers without :has(), which the CSS uses to show the
      // selected row's flavour selectors.
      radios.forEach(function (r) {
        var row = r.closest('[data-rytm-row]');
        if (row) row.classList.toggle('is-selected', r === radio);
      });

      var invalid = radio.getAttribute('data-invalid') === 'true';
      if (form) {
        if (invalid) form.dataset.invalid = 'true';
        else delete form.dataset.invalid;
      }
      if (button) button.disabled = invalid;
    }

    // Gallery first, so its rytmSetActive hooks exist before flavours use them.
    initGallery(root);
    initFlavours(root, applySelection);

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applySelection(radio);
      });
    });

    var checked = radios.filter(function (radio) { return radio.checked; })[0] || radios[0];
    if (checked) applySelection(checked);

    initAccordion(root);
    initCart(root);
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-varbox]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-varbox]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init when a merchant adds/reorders this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();